import Phaser from 'phaser';

import { BreackpointsX } from '../utils/enums/breackpoints';

import { EndGame } from './scenes/endGame';
import { ExitGame } from './scenes/exitGame';
import { Game } from './scenes/game';
import { GameOver } from './scenes/gameOver';
import { Loading } from './scenes/loading';
import { PauseGame } from './scenes/pauseGame';
import { Score } from './scenes/score';
import { StartMenu } from './scenes/startMenu';

const screenWidth = window.innerWidth;
const screenHeight = window.innerHeight;

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { y: 300, x: 0 },
      debug: false,
    },
  },
  audio: {
    disableWebAudio: false,
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: screenWidth >= BreackpointsX.LAPTOP ? BreackpointsX.LAPTOP : screenWidth,
    height: screenHeight,
  },
  scene: [Loading, StartMenu, Game, GameOver, ExitGame, EndGame, Score, PauseGame],
};

new Phaser.Game(config);
